import { ProductApi } from '../openapi';
import { config } from './config';

export const ProductClient = new ProductApi(config);
